<div [class.row]="isInline()" [class.justified]="isJustified()">
  <div [class.text-end]="isInlineOnly()" [class.col-sm-2]="isInline()" *ngIf="name">
    <label
      [class.col-form-label]="isInline()"
      class="form-label fw-bold"
      [placement]="'bottom'"
      [ngClass]="labelTooltipTemplate !== null ? 'field-tip' : ''"
      [ngbTooltip]="labelTooltipTemplate"
      >{{ name }}</label
    >
  </div>
  <div [class.col-sm-10]="isInline()">
    <shared-ui-inputs-select-field
      [options]="options"
      [multiple]="multiple"
      [tabIndex]="tabIndex"
      [parentFormGroup]="parentFormGroup"
      [formName]="formName"
      [name]="name"
      [resettable]="resettable"
      [filter]="filter"
      [setDefaultValue]="setDefaultValue"
      [placeholder]="placeholder"
      [disabled]="disabled"
    ></shared-ui-inputs-select-field>
  </div>
</div>
